import React from 'react';
import {AtNavBar} from 'taro-ui';
import styled from "styled-components";
const AtNavBarWrapper = styled.div<{
  bgColor: string;
  color: string;
}>`
  height: 100%;
  .at-nav-bar__left-view .at-icon,
  .at-nav-bar__container .at-icon{
    font-size: 14px;
  }
  .at-nav-bar__title{
    color: ${({color})=> color };
  }
  .at-nav-bar__text{
    font-size: 14px
  }
  .at-nav-bar{
    background: ${({bgColor})=> bgColor }
  }
`

const TNavBarWidget = (props:any) => {
  const {label, color, bgColor, onClickRgIconSt,onClickLeftIcon,title,leftIconType,rightFirstIconType,leftText} = props;
  return (
    <AtNavBarWrapper bgColor={bgColor} color={color}>
      <AtNavBar onClickRgIconSt={onClickRgIconSt} onClickLeftIcon={onClickLeftIcon} leftText={leftText}
      leftIconType={leftIconType} color={color} title={title} rightFirstIconType={rightFirstIconType} />
    </AtNavBarWrapper>
  );
};

export default TNavBarWidget;
